import React, { useState } from 'react'
import Clipboard from '../icons/Clipboard'
import Check from '../icons/Check'

const AvatarLink = ({ avatarUrl }) => {
  const [copied, setCopied] = useState(false)

  const handleCopyLink = () => {
    navigator.clipboard.writeText(avatarUrl).then(() => {
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 1000)
    })
  }

  return (
    <div className="flex w-full text-secondary-500 items-center justify-between h-[50px] px-4 bg-orange-50 border-2 border-primary rounded-xl">
      <div className="pr-3 truncate">
        <a href={avatarUrl} className="text-secondary-500">
          {avatarUrl}
        </a>
      </div>
      <a onClick={handleCopyLink}>{copied ? <Check /> : <Clipboard />}</a>
    </div>
  )
}

export default AvatarLink
